import { MULTI_TIME_SELECTION } from 'constants/constant';
import {
	FILTER_CONDITION_LABELS,
	STR_TMPT_LIST,
	OMNI_TMPT_LIST,
	OTIF_TMPT_LIST,
	DC_TMPT_LIST,
	ECOM_SALES_LIST,
	ECOM_INVENTORY,
	MUMD_ORDER_LIST,
	SHOW_CAL_INPUT,
	HAS_ALL_OF,
	HAS_ANY_OF,
	CONTAINS,
	member,
	PURCHASE_ORDER_LIST,
	REGISTER_SALES_LIST
} from 'constants/constant';
import { isCustomDataset } from 'helper/utils';

const isNotNull = 'is not null';
const isInBetween = 'is in between';
const monthToDate = 'Month to date';
const wmtLastWeek = 'WMT Last week';
const wmtLastTwoWeeks = 'WMT Last 2 weeks';
const wmtLastFourWeeks = 'WMT Last 4 weeks';
const wmtLastThirteenWeeks = 'WMT Last 13 weeks';
const wmtLastTwentySixWeeks = 'WMT Last 26 weeks';
export const wmtLastFiftyTwoWeeks = 'WMT Last 52 weeks';
export const wmtLastOneHundredAndFourWeeks = 'WMT Last 104 weeks';
const futureNNWeeks = 'Next {NN} weeks';
const wmtFutureNNWeeks = 'WMT Next {NN} weeks';

export const StringCondition = [
	{ label: FILTER_CONDITION_LABELS.IS_EQUAL_TO, value: 'is equal to' },
	{ label: FILTER_CONDITION_LABELS.IS_NOT_EQUAL_TO, value: 'is not equal to' },
	{ label: FILTER_CONDITION_LABELS.CONTAINS, value: 'contains' },
	{ label: FILTER_CONDITION_LABELS.DOES_NOT_CONTAIN, value: `doesn't contain` },
	{ label: FILTER_CONDITION_LABELS.START_WITH, value: 'start with' },
	{ label: FILTER_CONDITION_LABELS.DOES_NOT_START_WITH, value: `doesn't start with` },
	{ label: FILTER_CONDITION_LABELS.ENDS_WITH, value: 'ends with' },
	{ label: FILTER_CONDITION_LABELS.DOES_NOT_END_WITH, value: `doesn't end with` },
	{ label: FILTER_CONDITION_LABELS.IS_NULL, value: 'is null' },
	{ label: FILTER_CONDITION_LABELS.IS_NOT_NULL, value: isNotNull }
];

export const NumberCondition = [
	{ label: FILTER_CONDITION_LABELS.IS_EQUAL_TO, value: 'is equal to' },
	{ label: FILTER_CONDITION_LABELS.IS_NOT_EQUAL_TO, value: 'is not equal to' },
	{ label: FILTER_CONDITION_LABELS.IS_GREATER_THAN, value: 'is greater than' },
	{
		label: FILTER_CONDITION_LABELS.IS_GREATER_THAN_OR_EQUAL_TO,
		value: 'is greater than or equal to'
	},
	{ label: FILTER_CONDITION_LABELS.IS_LESS_THAN, value: 'is less than' },
	{ label: FILTER_CONDITION_LABELS.IS_LESS_THAN_OR_EQUAL_TO, value: `is less than or equal to` },
	{ label: FILTER_CONDITION_LABELS.IS_IN_BETWEEN, value: isInBetween },
	{ label: FILTER_CONDITION_LABELS.IS_NULL, value: 'is null' },
	{ label: FILTER_CONDITION_LABELS.IS_NOT_NULL, value: isNotNull }
];

/**
 * For canned reports we only display equals and not equals to condition
 */
export const EqualsToCondition = [
	{ label: FILTER_CONDITION_LABELS.IS_EQUAL_TO, value: 'is equal to' },
	{ label: FILTER_CONDITION_LABELS.IS_NOT_EQUAL_TO, value: 'is not equal to' }
];

/**
 * For store trait we only display equals to condition
 */
export const EqualsToConditionOnly = [
	{ label: FILTER_CONDITION_LABELS.IS_EQUAL_TO, value: 'is equal to' }
];

export const TraitNumberConditions = [
	{ label: FILTER_CONDITION_LABELS.HAS_ANY_OF, value: HAS_ANY_OF },
	{ label: FILTER_CONDITION_LABELS.HAS_ALL_OF, value: HAS_ALL_OF }
];

export const ContainsConditionOnly = [{ label: FILTER_CONDITION_LABELS.CONTAINS, value: CONTAINS }];

/** Other date condition when parent is not date */
export const otherDtConditions = [
	{ label: FILTER_CONDITION_LABELS.IS_EQUAL_TO, value: 'is equal to' },
	{ label: FILTER_CONDITION_LABELS.IS_LESS_THAN, value: 'is less than' },
	{ label: FILTER_CONDITION_LABELS.IS_LESS_THAN_OR_EQUAL_TO, value: `is less than or equal to` },
	{ label: FILTER_CONDITION_LABELS.IS_GREATER_THAN, value: 'is greater than' },
	{
		label: FILTER_CONDITION_LABELS.IS_GREATER_THAN_OR_EQUAL_TO,
		value: 'is greater than or equal to'
	},
	{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
];

/**
 * Commented WMT Year to date for Feb release.
 * Reason: to keep consistency between filter options provided in Quick reporting and regular flow
 */

/**
 * Commented Last 4 quarters, Last 12 months, Last year (2023).
 * Reason: Data is not correct for filters, they should be disabled until long term solution was found.
 */
export const DCWMTCal = {
	Date: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: 'Yesterday' },
		{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: 'WMT Week to date' },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_WEEK, value: wmtLastWeek },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_WEEKS, value: wmtLastTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_4_WEEKS, value: wmtLastFourWeeks },
		{ label: FILTER_CONDITION_LABELS.WEEKEND, value: 'Last Weekend [Fri-Sat-Sun]' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Week: [
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_WEEK, value: wmtLastWeek },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_WEEKS, value: wmtLastTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_4_WEEKS, value: wmtLastFourWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_13_WEEKS, value: wmtLastThirteenWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_26_WEEKS, value: wmtLastTwentySixWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_52_WEEKS, value: wmtLastFiftyTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_104_WEEKS, value: wmtLastOneHundredAndFourWeeks },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Month: [
		{ label: FILTER_CONDITION_LABELS.MONTH_TO_DATE, value: monthToDate },
		{ label: FILTER_CONDITION_LABELS.LAST_MONTH, value: 'Last month' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_MONTHS, value: `Last 2 months` },
		{ label: FILTER_CONDITION_LABELS.LAST_3_MONTHS, value: 'Last 3 months' },
		{ label: FILTER_CONDITION_LABELS.LAST_6_MONTHS, value: 'Last 6 months' }
		// { label: FILTER_CONDITION_LABELS.LAST_12_MONTHS, value: 'Last 12 months' }
	],
	Quarter: [
		{ label: FILTER_CONDITION_LABELS.WMT_QUARTER_TO_DATE, value: 'WMT Quarter to date' },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_QUARTER, value: 'WMT Last quarter' },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_QUARTERS, value: `WMT Last 2 quarters` }
		// { label: FILTER_CONDITION_LABELS.WMT_LAST_4_QUARTERS, value: `WMT Last 4 quarters` }
	],
	Year: [
		{
			label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE_CURR_YR,
			value: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE_CURR_YR
		}
		// {
		// 	label: FILTER_CONDITION_LABELS.WMT_LAST_YEAR,
		// 	value: FILTER_CONDITION_LABELS.WMT_LAST_YEAR
		// }
	]
};

export const SSIStdCal = {
	Date: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: ' Yesterday' },
		{ label: FILTER_CONDITION_LABELS.WEEK_TO_DATE, value: 'Week to date' },
		{ label: FILTER_CONDITION_LABELS.LAST_WEEK, value: 'Last week' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_WEEKS, value: `Last 2 weeks` },
		{ label: FILTER_CONDITION_LABELS.MONTH_TO_DATE, value: monthToDate },
		{ label: FILTER_CONDITION_LABELS.QUARTER_TO_DATE, value: 'Quarter to date' },
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Week: [
		{ label: FILTER_CONDITION_LABELS.WEEK_TO_DATE, value: 'Week to date' },
		{ label: FILTER_CONDITION_LABELS.LAST_WEEK, value: 'Last week' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_WEEKS, value: `Last 2 weeks` },
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Month: [
		{ label: FILTER_CONDITION_LABELS.MONTH_TO_DATE, value: monthToDate },
		{ label: FILTER_CONDITION_LABELS.LAST_MONTH, value: 'Last month' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_MONTHS, value: `Last 2 months` },
		{ label: FILTER_CONDITION_LABELS.LAST_3_MONTHS, value: 'Last 3 months' },
		{ label: FILTER_CONDITION_LABELS.LAST_6_MONTHS, value: 'Last 6 months' }
	],
	Quarter: [
		{ label: FILTER_CONDITION_LABELS.QUARTER_TO_DATE, value: 'Quarter to date' },
		{ label: FILTER_CONDITION_LABELS.LAST_QUARTER, value: 'Last quarter' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_QUARTERS, value: 'Last 2 quarters' }
	],
	Year: [
		{
			label: FILTER_CONDITION_LABELS.YEAR_TO_DATE_CURR_YR,
			value: FILTER_CONDITION_LABELS.YEAR_TO_DATE_CURR_YR
		}
	]
};

export const OmniWMTCal = {
	Date: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: 'Yesterday' },
		{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: 'WMT Week to date' },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_WEEK, value: wmtLastWeek },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_WEEKS, value: wmtLastTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_4_WEEKS, value: wmtLastFourWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_13_WEEKS, value: wmtLastThirteenWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_26_WEEKS, value: wmtLastTwentySixWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_52_WEEKS, value: wmtLastFiftyTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.WEEKEND, value: 'Last Weekend [Fri-Sat-Sun]' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Week: [
		{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: 'WMT Week to date' },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_WEEK, value: wmtLastWeek },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_WEEKS, value: wmtLastTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_4_WEEKS, value: wmtLastFourWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_13_WEEKS, value: wmtLastThirteenWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_26_WEEKS, value: wmtLastTwentySixWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_52_WEEKS, value: wmtLastFiftyTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_104_WEEKS, value: wmtLastOneHundredAndFourWeeks },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Month: [
		{ label: FILTER_CONDITION_LABELS.MONTH_TO_DATE, value: monthToDate },
		{ label: FILTER_CONDITION_LABELS.LAST_MONTH, value: 'Last month' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_MONTHS, value: `Last 2 months` },
		{ label: FILTER_CONDITION_LABELS.LAST_3_MONTHS, value: 'Last 3 months' },
		{ label: FILTER_CONDITION_LABELS.LAST_6_MONTHS, value: 'Last 6 months' }
		// { label: FILTER_CONDITION_LABELS.LAST_12_MONTHS, value: 'Last 12 months' }
	],
	Quarter: [
		{ label: FILTER_CONDITION_LABELS.WMT_QUARTER_TO_DATE, value: 'WMT Quarter to date' },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_QUARTER, value: 'WMT Last quarter' },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_QUARTERS, value: `WMT Last 2 quarters` }
		// { label: FILTER_CONDITION_LABELS.WMT_LAST_4_QUARTERS, value: `WMT Last 4 quarters` }
	],
	Year: [
		{
			label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE_CURR_YR,
			value: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE_CURR_YR
		}
		// {
		// 	label: FILTER_CONDITION_LABELS.WMT_LAST_YEAR,
		// 	value: FILTER_CONDITION_LABELS.WMT_LAST_YEAR
		// }
	]
};

export const HistoricalReportOmniCal = {
	Date: [
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LY_LAST_4_WEEK, value: 'WMT LY Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LY_LAST_13_WEEK, value: 'WMT LY Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LY_LAST_26_WEEK, value: 'WMT LY Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LLY_LAST_4_WEEKS, value: 'WMT LLY Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LLY_LAST_13_WEEKS, value: 'WMT LLY Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LLY_LAST_26_WEEKS, value: 'WMT LLY Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Week: [
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_104_WEEKS, value: 'Last 104 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_156_WEEKS, value: 'Last 156 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LY_LAST_26_WEEK, value: 'WMT LY Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LY_LAST_52_WEEK, value: 'WMT LY Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LLY_LAST_26_WEEKS, value: 'WMT LLY Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.WMT_LLY_LAST_52_WEEKS, value: 'WMT LLY Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	]
};

export const SSIWMTCal = { ...OmniWMTCal };

export const MUMDMTCal = { ...OmniWMTCal };

export const POCal = {
	poCreateDay: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: ' Yesterday' },
		{ label: FILTER_CONDITION_LABELS.LAST_WEEK, value: 'Last week' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_WEEKS, value: `Last 2 weeks` },
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' },
		{ label: FILTER_CONDITION_LABELS.CURRENT_WEEK, value: 'Current week' }
	],
	poShipDate: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: ' Yesterday' },
		{ label: FILTER_CONDITION_LABELS.LAST_WEEK, value: 'Last week' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_WEEKS, value: `Last 2 weeks` },
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' },
		{ label: FILTER_CONDITION_LABELS.CURRENT_WEEK, value: 'Current week' },
		{ label: FILTER_CONDITION_LABELS.NEXT_2_WK, value: futureNNWeeks.replace('{NN}', '2') },
		{ label: FILTER_CONDITION_LABELS.NEXT_4_WK, value: futureNNWeeks.replace('{NN}', '4') },
		{ label: FILTER_CONDITION_LABELS.NEXT_13_WK, value: futureNNWeeks.replace('{NN}', '13') },
		{ label: FILTER_CONDITION_LABELS.NEXT_26_WK, value: futureNNWeeks.replace('{NN}', '26') },
		{ label: FILTER_CONDITION_LABELS.NEXT_52_WK, value: futureNNWeeks.replace('{NN}', '52') }
	],
	mustArriveDate: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: ' Yesterday' },
		{ label: FILTER_CONDITION_LABELS.LAST_WEEK, value: 'Last week' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_WEEKS, value: `Last 2 weeks` },
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' },
		{ label: FILTER_CONDITION_LABELS.CURRENT_WEEK, value: 'Current week' },
		{ label: FILTER_CONDITION_LABELS.NEXT_2_WK, value: futureNNWeeks.replace('{NN}', '2') },
		{ label: FILTER_CONDITION_LABELS.NEXT_4_WK, value: futureNNWeeks.replace('{NN}', '4') },
		{ label: FILTER_CONDITION_LABELS.NEXT_13_WK, value: futureNNWeeks.replace('{NN}', '13') },
		{ label: FILTER_CONDITION_LABELS.NEXT_26_WK, value: futureNNWeeks.replace('{NN}', '26') },
		{ label: FILTER_CONDITION_LABELS.NEXT_52_WK, value: futureNNWeeks.replace('{NN}', '52') }
	],
	receivedDate: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: ' Yesterday' },
		{ label: FILTER_CONDITION_LABELS.LAST_WEEK, value: 'Last week' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_WEEKS, value: `Last 2 weeks` },
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' },
		{ label: FILTER_CONDITION_LABELS.CURRENT_WEEK, value: 'Current week' }
	]
};

export const POWMTCal = {
	wmtCalendar: [
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_WEEK, value: wmtLastWeek },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_WEEKS, value: wmtLastTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_4_WEEKS, value: wmtLastFourWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_13_WEEKS, value: wmtLastThirteenWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_26_WEEKS, value: wmtLastTwentySixWeeks },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_52_WEEKS, value: wmtLastFiftyTwoWeeks },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' },
		{ label: FILTER_CONDITION_LABELS.WMT_NXT_2_WK, value: wmtFutureNNWeeks.replace('{NN}', '2') },
		{ label: FILTER_CONDITION_LABELS.WMT_NXT_4_WK, value: wmtFutureNNWeeks.replace('{NN}', '4') },
		{ label: FILTER_CONDITION_LABELS.WMT_NXT_13_WK, value: wmtFutureNNWeeks.replace('{NN}', '13') },
		{ label: FILTER_CONDITION_LABELS.WMT_NXT_26_WK, value: wmtFutureNNWeeks.replace('{NN}', '26') },
		{ label: FILTER_CONDITION_LABELS.WMT_NXT_52_WK, value: wmtFutureNNWeeks.replace('{NN}', '52') }
	]
};

export const OmniStdCal = {
	Date: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: ' Yesterday' },
		{ label: FILTER_CONDITION_LABELS.WEEK_TO_DATE, value: 'Week to date' },
		{ label: FILTER_CONDITION_LABELS.LAST_WEEK, value: 'Last week' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_WEEKS, value: `Last 2 weeks` },
		{ label: FILTER_CONDITION_LABELS.MONTH_TO_DATE, value: monthToDate },
		{ label: FILTER_CONDITION_LABELS.QUARTER_TO_DATE, value: 'Quarter to date' },
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Week: [
		{ label: FILTER_CONDITION_LABELS.WEEK_TO_DATE, value: 'Week to date' },
		{ label: FILTER_CONDITION_LABELS.LAST_WEEK, value: 'Last week' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_WEEKS, value: `Last 2 weeks` },
		{ label: FILTER_CONDITION_LABELS.LAST_4_WEEKS, value: 'Last 4 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_13_WEEKS, value: 'Last 13 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_26_WEEKS, value: 'Last 26 weeks' },
		{ label: FILTER_CONDITION_LABELS.LAST_52_WEEKS, value: 'Last 52 weeks' },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	],
	Month: [
		{ label: FILTER_CONDITION_LABELS.MONTH_TO_DATE, value: monthToDate },
		{ label: FILTER_CONDITION_LABELS.LAST_MONTH, value: 'Last month' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_MONTHS, value: `Last 2 months` },
		{ label: FILTER_CONDITION_LABELS.LAST_3_MONTHS, value: 'Last 3 months' },
		{ label: FILTER_CONDITION_LABELS.LAST_6_MONTHS, value: 'Last 6 months' }
	],
	Quarter: [
		{ label: FILTER_CONDITION_LABELS.QUARTER_TO_DATE, value: 'Quarter to date' },
		{ label: FILTER_CONDITION_LABELS.LAST_QUARTER, value: 'Last quarter' },
		{ label: FILTER_CONDITION_LABELS.LAST_2_QUARTERS, value: 'Last 2 quarters' }
	],
	Year: [
		{
			label: FILTER_CONDITION_LABELS.YEAR_TO_DATE_CURR_YR,
			value: FILTER_CONDITION_LABELS.YEAR_TO_DATE_CURR_YR
		}
	]
};

export const StoreDemandCal = {
	Week: [
		{ label: FILTER_CONDITION_LABELS.WMT_CURR_WK, value: 'WMT Current week' },
		{ label: FILTER_CONDITION_LABELS.WMT_LAST_WEEK, value: wmtLastWeek },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	]
};

// export const orderDimDtField = [
// 	{ label: FILTER_CONDITION_LABELS.WMT_NXT_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_WK },
// 	{ label: FILTER_CONDITION_LABELS.WMT_NXT_2_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_2_WK },
// 	{ label: FILTER_CONDITION_LABELS.WMT_NXT_4_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_4_WK },
// 	{ label: FILTER_CONDITION_LABELS.WMT_NXT_13_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_13_WK },
// 	{ label: FILTER_CONDITION_LABELS.WMT_NXT_26_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_26_WK },
// 	{ label: FILTER_CONDITION_LABELS.CUSTOM, value: FILTER_CONDITION_LABELS.CUSTOM }
// ];

export const customDtCondition = [{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }];

export const demandFrcstWkCal = [
	{ label: FILTER_CONDITION_LABELS.WMT_CURR_WK, value: ` ${FILTER_CONDITION_LABELS.WMT_CURR_WK}` },
	{ label: FILTER_CONDITION_LABELS.WMT_NXT_WK, value: ` ${FILTER_CONDITION_LABELS.WMT_NXT_WK}` },
	{
		label: FILTER_CONDITION_LABELS.WMT_NXT_4_WK,
		value: ` ${FILTER_CONDITION_LABELS.WMT_NXT_4_WK}`
	},
	{
		label: FILTER_CONDITION_LABELS.WMT_NXT_13_WK,
		value: ` ${FILTER_CONDITION_LABELS.WMT_NXT_13_WK}`
	},
	{
		label: FILTER_CONDITION_LABELS.WMT_NXT_26_WK,
		value: ` ${FILTER_CONDITION_LABELS.WMT_NXT_26_WK}`
	},
	{
		label: FILTER_CONDITION_LABELS.WMT_NXT_52_WK,
		value: ` ${FILTER_CONDITION_LABELS.WMT_NXT_52_WK}`
	},
	{
		label: FILTER_CONDITION_LABELS.WMT_NXT_104_WK,
		value: ` ${FILTER_CONDITION_LABELS.WMT_NXT_104_WK}`
	},
	{ label: FILTER_CONDITION_LABELS.CUSTOM, value: FILTER_CONDITION_LABELS.CUSTOM }
];

export const orderFrcstWkCal = [
	{ label: FILTER_CONDITION_LABELS.WMT_CURR_WK, value: FILTER_CONDITION_LABELS.WMT_CURR_WK },
	{ label: FILTER_CONDITION_LABELS.WMT_NXT_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_WK },
	{ label: FILTER_CONDITION_LABELS.WMT_NXT_4_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_4_WK },
	{ label: FILTER_CONDITION_LABELS.WMT_NXT_13_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_13_WK },
	{ label: FILTER_CONDITION_LABELS.WMT_NXT_26_WK, value: FILTER_CONDITION_LABELS.WMT_NXT_26_WK },
	{ label: FILTER_CONDITION_LABELS.CUSTOM, value: FILTER_CONDITION_LABELS.CUSTOM }
];

export const StoreOrderCal = {
	Week: [
		{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: FILTER_CONDITION_LABELS.YESTERDAY },
		{ label: FILTER_CONDITION_LABELS.TODAY, value: FILTER_CONDITION_LABELS.TODAY },
		{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
	]
};

export const MultiTimeSelCal = [
	{
		label: FILTER_CONDITION_LABELS.SELECT_ALL,
		value: 'Select All'
	},
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_WEEK, value: wmtLastWeek },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_WEEKS, value: wmtLastTwoWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_4_WEEKS, value: wmtLastFourWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_13_WEEKS, value: wmtLastThirteenWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_26_WEEKS, value: wmtLastTwentySixWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_52_WEEKS, value: wmtLastFiftyTwoWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_104_WEEKS, value: wmtLastOneHundredAndFourWeeks },
	{ label: FILTER_CONDITION_LABELS.CUSTOM, value: 'Custom' }
];

export const hideValueInput = (condition, dataType = undefined) => {
	const list = ['is null', isNotNull, isInBetween, 'Custom', 'On', 'After', 'Before'];
	if (list.includes(condition)) {
		return true;
	} else if (dataType === 'date') {
		return true;
	}
	return false;
};

export const isNullField = (condition) => {
	return ['is null', isNotNull].includes(condition);
};

export const getInputLenAllowed = (condition) => {
	if (
		[
			'is greater than',
			'is greater than or equal to',
			'is less than',
			'is less than or equal to'
		].includes(condition)
	) {
		return 1;
	}

	if ([isInBetween, 'Custom'].includes(condition)) {
		return 1;
	}
	return 200;
};

export const shouldShowRangeInput = (condition) => {
	return [isInBetween].includes(condition);
};

export const hideDateRangeInput = (_item) => {
	const {
		filter: { condition }
	} = _item;

	if (SHOW_CAL_INPUT.includes(condition) && _item.dataType === 'date') {
		return false;
	}

	return true;
};

export const isCalFamily = (o) => {
	const { dataType, businessName } = o;
	if (dataType === 'date' && member.includes(businessName)) {
		return true;
	}
	return false;
};

export const isMultiTimeFilterEnabled = (o, templateId) => {
	const multiTimeTemplateList = [
		...STR_TMPT_LIST,
		...OMNI_TMPT_LIST,
		...OTIF_TMPT_LIST,
		...DC_TMPT_LIST,
		...ECOM_SALES_LIST,
		...ECOM_INVENTORY,
		...MUMD_ORDER_LIST,
		...PURCHASE_ORDER_LIST,
		...REGISTER_SALES_LIST
	];
	const { dataType, businessName, parent } = o;
	return (
		(multiTimeTemplateList.includes(templateId) || isCustomDataset(templateId)) &&
		dataType === 'date' &&
		parent?.substring(0, 3) === 'Wal' &&
		businessName === 'Week'
	);
};

export const isMultiWeekSel = (o, templateId) => {
	// If it is a CDS with mod only tables, then time is not available due to which 'o' will be undefined.
	if (!o) {
		return false;
	}
	const { filter } = o;
	if (isMultiTimeFilterEnabled(o, templateId)) {
		return filter?.condition?.split(',').length > 1;
	}
	return false;
};

export const isMTS = (filter) => {
	return filter?.localName === MULTI_TIME_SELECTION;
};

export const isMTSAndNotDefault = (filter) => {
	return filter?.localName === MULTI_TIME_SELECTION && Object.keys(filter?.mts ?? {}).length > 0;
};
